import axios from 'axios';
import { API_URL, TIMEOUTS } from '@/utils/constants';


export class HttpClient {
  constructor(baseURL, licenseToken) {
    this.licenseToken = licenseToken;
    this.baseURL = baseURL || API_URL;

    this.client = axios.create({
      baseURL: this.baseURL,
      timeout: TIMEOUTS.API_REQUEST,
      headers: {
        'Content-Type': 'application/json'
      }
    });

    this.client.interceptors.request.use((config) => {
      if (this.licenseToken) {
        config.headers.Authorization = `Bearer ${this.licenseToken}`;
      }
      return config;
    });
  }


  handleError(error) {
    if (error.response) {
      const data = error.response.data;
      const status = error.response.status;

      const errorInfo = {
        statusCode: status,
        errorCode: data.error_code || 'UNKNOWN_ERROR',
        message: data.message || 'Request failed',
        retryAfter: data.retry_after_seconds || null
      };

      throw new Error(JSON.stringify(errorInfo));
    } else if (error.request) {
      throw new Error(
        JSON.stringify({
          statusCode: 503,
          errorCode: 'NETWORK_ERROR',
          message: 'No response from server',
          retryAfter: null
        })
      );
    } else {
      throw new Error(
        JSON.stringify({
          statusCode: 500,
          errorCode: 'INTERNAL_ERROR',
          message: error.message,
          retryAfter: null
        })
      );
    }
  }


  async get(url, config = {}) {
    try {
      const response = await this.client.get(url, config);
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }


  async post(url, data, config = {}) {
    try {
      const response = await this.client.post(url, data, config);
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  
  async put(url, data, config = {}) {
    try {
      const response = await this.client.put(url, data, config);
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }


  async patch(url, data, config = {}) {
    try {
      const response = await this.client.patch(url, data, config);
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }


  async delete(url, config = {}) {
    try {
      const response = await this.client.delete(url, config);
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }


  getClient() {
    return this.client;
  }
}
